// extracted by mini-css-extract-plugin
export const root = "quote-text-row-module--root--1z6bG";
export const quote = "quote-text-row-module--quote--xpH3S";
export const text = "quote-text-row-module--text--2fSMZ";